var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size", "color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      _a$color = a.color,
      d = _a$color === void 0 ? "#d18900" : _a$color,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    }, d ? {
      fill: d
    } : {})
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "towergit-plain-a",
    d: "M85.512 48.8l-.586-3.277a.353.353 0 00-.352-.296h-40.96a.353.353 0 00-.352.296l-.586 3.278zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "towergit-plain-b",
    d: "M37.71 20.625H90.5l-.727-2.7a.411.411 0 00-.398-.3H38.727a.43.43 0 00-.403.313zm0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.61 45.23H44.585v-1.42h39.023zM71.613 30.04h1.524v13.773h-1.524zm-16.562 0h1.523v13.773h-1.523zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.09 30.04h1.523v13.773H82.09zm-37.505-.003h1.524V43.81h-1.524z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.512 48.8l-.586-3.277a.353.353 0 00-.352-.296h-40.96a.353.353 0 00-.352.296l-.586 3.278zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.71 20.625H90.5l-.727-2.7a.411.411 0 00-.398-.3H38.727a.43.43 0 00-.403.313zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    fillOpacity: "0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.71 20.625H90.5l-.727-2.7a.411.411 0 00-.398-.3H38.727a.43.43 0 00-.403.313zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.512 48.8l-.586-3.277a.353.353 0 00-.352-.296h-40.96a.353.353 0 00-.352.296l-.586 3.278zm0 0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M97.836 63.125l-1.46-5.898a.718.718 0 00-.7-.55h-63.2a.712.712 0 00-.703.55l-1.449 5.9a.348.348 0 00.05.287L41.461 80.3a.68.68 0 00.562.3h44.14a.681.681 0 00.564-.3l11.085-16.887c.024-.09.05-.187.024-.29zm-61.999-7.361c.108-.434 1.049-5.667 1.05-5.833 0-.065 12.237-.118 27.192-.118l27.192.05c0 .028.247 1.393.55 3.034L92.372 56c.001.065-12.739.118-28.311.118H35.749zm-.054-26.426c0-.077-.248-1.757-.552-3.733l-.552-3.722c0-.071 13.251-.129 29.446-.129h29.446l-.59 3.823-.599 3.862c-.028.119-56.601.018-56.601-.101zm10.124 77.924l-.35-.245V80.709h37.044v26.308l-.35.245c-.312.219-2.297.245-18.172.245s-17.86-.027-18.172-.245zm1.962 2.821c-.058-.058-.106-.555-.106-1.104v-.998h32.33l-.047 1.064-.047 1.064-16.012.04c-8.807.022-16.06-.007-16.118-.066z"
  }));
};